module.exports = __webpack_public_path__ + "1a94b558f407616f6639806ebd1ded4b.png";